import React from "react"

const TabsMenu = ({ children }) => {
  return <div className="tabs-menu">{children}</div>
}

export default TabsMenu
